import React from 'react';
import { MainFrameContainer } from './MainFrame.styles';
interface Props {
  backgroundColor?: string;
}

export const MainFrame: React.FC<Props> = ({ children, backgroundColor }) => {
  return <MainFrameContainer backgroundColor={backgroundColor}>{children}</MainFrameContainer>;
};
